<script setup lang="ts">
import { error, warningSign } from '@/components/icons/icons.ts';
import { useLicenseStore } from '@/stores/licenseStore.ts';
import LicenseExpirationInfoDialog from '@/views/LicensesView/components/LicenseExpirationInfoDialog.vue';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { useTranslation } from 'i18next-vue';
import { useAuthenticationStore } from '@/stores/authenticationStore.ts';

const { isAuthenticated } = storeToRefs(useAuthenticationStore());
const { t } = useTranslation();
const licenseStore = useLicenseStore();
const { earliestExpirationDays, licenseHasExpired, expiredDeviceLicenses } =
  storeToRefs(licenseStore);

const showMoreInfoDialog = ref(false);

const hasExpiredParts = computed(() => licenseHasExpired.value || expiredDeviceLicenses.value.size);

const deviceLicenseWarningText = computed(() =>
  expiredDeviceLicenses.value.size
    ? t('SomeLicenseFeaturesHaveExpired')
    : t('SomeLicenseFeaturesWillExpireIn_count_Days', {
        count: earliestExpirationDays.value,
      }),
);

const licenseWarningText = computed(() =>
  licenseHasExpired.value ? t('LicenseHasExpiredMsg') : deviceLicenseWarningText,
);

function showLicenseExpirationInfoDialog() {
  showMoreInfoDialog.value = true;
}
</script>

<template>
  <template v-if="isAuthenticated">
    <div
      class="license-expiry-warning"
      :class="{
        'bg-error-darken-1': hasExpiredParts,
        'bg-warning-darken-1': !hasExpiredParts,
      }"
    >
      <v-icon class="mr-2" size="20">{{ hasExpiredParts ? error : warningSign }}</v-icon>
      <div>
        {{ licenseWarningText }}
        <a href="#" @click.stop="showLicenseExpirationInfoDialog">
          {{ $t('ShowMore') }}
        </a>
      </div>
    </div>
    <LicenseExpirationInfoDialog v-model="showMoreInfoDialog" />
  </template>
</template>

<style scoped lang="scss">
.license-expiry-warning {
  display: flex;
  color: rgb(var(--v-theme-off-white));
  align-items: center;
  justify-content: center;

  flex-grow: 1;
  height: 100%;
}
</style>
